var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSumka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.87,15.34a.53.53,0,0,1-.53-.53V10.35A2.21,2.21,0,0,0,16,8.28a2.21,2.21,0,0,0-2.34,2.07v4.31a.53.53,0,0,1-1.06,0V10.35A3.28,3.28,0,0,1,16,7.22a3.28,3.28,0,0,1,3.4,3.13v4.46A.53.53,0,0,1,18.87,15.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,3.06A12.94,12.94,0,1,0,28.94,16,12.95,12.95,0,0,0,16,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,24.2H10a.53.53,0,0,1-.53-.53V13.14a.53.53,0,0,1,.53-.53H22a.53.53,0,0,1,.53.53V23.67A.53.53,0,0,1,22,24.2ZM10.54,23.15H21.46V13.66H10.54Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSumka);
export default __webpack_public_path__ + "static/media/sumka.4b132188ff8415080dfa932df8a621bc.svg";
export { ForwardRef as ReactComponent };